import React, { useState } from 'react';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import images from '../../assets';

import colors from '../../libs/colors';
import { Button, Modal, Fade, FormGroup, FormControlLabel, Checkbox, InputBase } from '@material-ui/core';

import { HorizontalSp, VerticalSp, MediaQuery, ModalContents, ModalTitle, ModalNorBtn } from '../Common';

import { BoxInImage } from '../HomePage';
import getPrewImage from '../../_utils/preview';
import styled, { css } from 'styled-components';
import store from '../../store';
import apiClient from '../../_utils/axios';
import { useTranslation } from 'react-i18next';
import Store from 'store';
import LoginPage from '../../views/auth/LoginPage';
import { orange } from '@material-ui/core/colors';
import './survey-mui.scss';
import { InputGroup, InputPlaceHolder, inputStyle } from '../auth/login';
import { BorderBtn } from '../mypage/Purchase';
import { getModalWidh, getSemiBigModalWidh } from '../../_utils/modalWidh';
import { CONFIG_MESSAGE } from '../../libs/config';
import { getStringByLang } from '../../libs/lang';

export const GroupCatagoryName = ({ children }) => {
  return (
    <>
      <BrowserView>
        <div style={{ fontFamily: 'NSCJKrR', fontSize: 30, color: 'black' }}>{children}</div>
      </BrowserView>
      <MobileView>
        <div style={{ fontFamily: 'NSCJKrR', fontSize: 20, color: 'black' }}>{children}</div>
      </MobileView>
    </>
  );
};

export const CatagoryName = ({ children }) => {
  return (
    <>
      <BrowserView>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: 30, color: 'black' }}>{children}</div>
      </BrowserView>
      <MobileView>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: 20, color: 'black' }}>{children}</div>
      </MobileView>
    </>
  );
};

export const CountNum = ({ children }) => {
  return (
    <>
      <BrowserView>
        <div style={{ fontFamily: 'NSCJKrL', fontSize: 18, color: 'black' }}>{children}</div>
      </BrowserView>
      <MobileView>
        <div style={{ fontFamily: 'NSCJKrL', fontSize: 12, color: 'black' }}>{children}</div>
      </MobileView>
    </>
  );
};

export const FilterOption = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <BrowserView>
        <Button size="small" onClick={onClick} variant="outlined" style={{}}>
          <img alt="" src={images.icon_filter} />
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', marginLeft: 10 }}>{t('filter')}</div>
        </Button>
      </BrowserView>
      <MobileView>
        <Button size="small" onClick={onClick} style={{ minWidth: 20 }}>
          <img alt="" src={images.icon_filter} />
        </Button>
      </MobileView>
    </>
  );
};

export const SortBtn = ({ onClick, title, active = false }) => {
  return (
    <div
      onClick={onClick}
      style={{
        fontFamily: active ? 'NSCJKrB' : 'NSCJKrR',
        fontSize: 18,
        color: active ? colors.active : 'black',
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      {active ? <div style={{ color: 'rgb(0,0,0,0)' }}>{title}</div> : title}
      {active && isBrowser && (
        <div style={{ backgroundColor: colors.active, width: '100%', height: 2, position: 'absolute', bottom: -1 }} />
      )}
      {active && <div style={{ position: 'absolute', top: 0 }}>{title}</div>}
    </div>
  );
};

export const SortGroup = ({ onSelect, value = '' }) => {
  const { t } = useTranslation();
  const [showmenu, setShowmenu] = useState(false);

  const onClick = (val) => {
    onSelect && onSelect(val);
  };
  return (
    <>
      <MediaQuery min={655}>
        <div style={{ display: 'flex' }}>
          <SortBtn
            title={t('sort_recent')}
            onClick={() => {
              onClick('');
            }}
            active={value === ''}
          />
          <HorizontalSp sp={18} />
          <SortBtn
            title={t('sort_popular')}
            onClick={() => {
              onClick('order_count');
            }}
            active={value === 'order_count'}
          />
          <HorizontalSp sp={18} />
          <SortBtn
            title={t('sort_picks')}
            onClick={() => {
              onClick('interest_count');
            }}
            active={value === 'interest_count'}
          />
          <HorizontalSp sp={18} />
          <SortBtn
            title={t('sort_low_to_high')}
            onClick={() => {
              onClick('price_asc');
            }}
            active={value === 'price_asc'}
          />
          <HorizontalSp sp={18} />
          <SortBtn
            title={t('sort_high_to_low')}
            onClick={() => {
              onClick('price_desc');
            }}
            active={value === 'price_desc'}
          />
        </div>
      </MediaQuery>
      <MediaQuery max={654}>
        <div
          onClick={() => {
            setShowmenu(!showmenu);
          }}
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 18,
            color: colors.active,
            cursor: 'pointer',
            position: 'relative',
            padding: '6px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {value === '' && t('sort_recent')}
          {value === 'order_count' && t('sort_popular')}
          {value === 'interest_count' && t('sort_picks')}
          {value === 'price_asc' && t('sort_low_to_high')}
          {value === 'price_desc' && t('sort_high_to_low')}
          <img alt="" src={images.expandmore_act} style={{ marginLeft: 10 }} />
          {showmenu && (
            <div
              style={{
                position: 'absolute',
                backgroundColor: 'white',
                zIndex: 99,
                padding: '6px 10px',
                width: 'max-content',
                left: 0,
                top: 35,
                border: '1px solid #999999',
              }}
            >
              <SortBtn
                title={t('sort_recent')}
                onClick={() => {
                  setShowmenu(false);
                  onClick('');
                }}
                active={value === ''}
              />
              <VerticalSp sp={8} />
              <SortBtn
                title={t('sort_popular')}
                onClick={() => {
                  setShowmenu(false);
                  onClick('order_count');
                }}
                active={value === 'order_count'}
              />
              <VerticalSp sp={8} />
              <SortBtn
                title={t('sort_picks')}
                onClick={() => {
                  setShowmenu(false);
                  onClick('interest_count');
                }}
                active={value === 'interest_count'}
              />
              <VerticalSp sp={8} />
              <SortBtn
                title={t('sort_low_to_high')}
                onClick={() => {
                  setShowmenu(false);
                  onClick('price_asc');
                }}
                active={value === 'price_asc'}
              />
              <VerticalSp sp={8} />
              <SortBtn
                title={t('sort_high_to_low')}
                onClick={() => {
                  setShowmenu(false);
                  onClick('price_desc');
                }}
                active={value === 'price_desc'}
              />
            </div>
          )}
        </div>
      </MediaQuery>
    </>
  );
};

export const COLORBOX = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 5px;
  cursor: pointer;
`;

const SelectedBtn = styled.div`
  background-color: #f1f1f1;
  height: 36px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 0 12px;
  margin-right: 10px;
  margin-bottom: 8px;
`;

export const OptionSelected = ({ className, children, style, onClick }) => {
  return (
    <SelectedBtn className={className} style={style}>
      {children}
      <div
        onClick={onClick}
        style={{
          cursor: 'pointer',
          marginLeft: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <img alt="" src={images.icon_close} style={{ width: 10, height: 10 }} />
      </div>
    </SelectedBtn>
  );
};

export const TagListSelected = ({ className, children, style, onClick }) => {
  return (
    <SelectedBtn
      style={{
        cursor: 'pointer',
        marginLeft: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 10,
        paddingBottom: 10,
        ...style,
      }}
      onClick={onClick}
      className={className}
    >
      {children}
    </SelectedBtn>
  );
};

export const SelectedTxt = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16;
  color: black;
  line-height: 18px;
  margin-top: -2;
`;

export const ColorRegBtn = styled.div`
  width: 120px;
  height: 36px;
  font-family: 'NSCJKrB';
  font-size: 16px;
  color: white;
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  background-color: #ff8a06;
  cursor: pointer;
`;

const Favitem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  margin: 10px;
  border-radius: 10px;
`;

const FavRegBtn = styled.div`
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'NSCJKrB';
  font-size: 16px;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;

export const FavDesignItem = ({ title, favimg, state, onRegClick, onUnRegClick }) => {
  const [onOver, setOnover] = useState(false);
  const { t } = useTranslation();
  return (
    <Favitem
      style={{ backgroundColor: onOver ? '#f1f1f1' : '#f7f7f7', alignItems: isMobile ? 'stretch' : 'center' }}
      onMouseEnter={() => {
        setOnover(true);
      }}
      onMouseLeave={() => {
        setOnover(false);
      }}
      onClick={() => {
        if (state === false) {
          onRegClick();
        } else {
          onUnRegClick();
        }
      }}
    >
      {isMobile && <BoxInImage style={{ width: 80, height: 80, marginRight: 12, backgroundImage: `url(${favimg})` }} />}
      {isMobile && (
        <div
          style={{
            flex: 1,
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {title && title === '기본' ? <>{t('faveorite_baic')}</> : <>{title}</>}
          <FavRegBtn style={{ opacity: 1, backgroundColor: state === false ? '#ff8a06' : '#cccccc' }}>
            {state === false ? t('save') : t('saved')}
          </FavRegBtn>
        </div>
      )}
      {isBrowser && (
        <>
          <BoxInImage style={{ width: 80, height: 80, backgroundImage: `url(${favimg})` }} />
          <HorizontalSp sp={10} />
          <div style={{ flex: 1, fontFamily: 'NSCJKrR', fontSize: 16, color: 'black' }}>
            {title && title === '기본' ? <>{t('faveorite_baic')}</> : <>{title}</>}
          </div>
          <HorizontalSp sp={10} />
          <FavRegBtn style={{ opacity: 1, backgroundColor: state === false ? '#ff8a06' : '#cccccc' }}>
            {state === false ? t('save') : t('saved')}
          </FavRegBtn>
        </>
      )}
    </Favitem>
  );
};

export const PlzLoginModal = ({ props, show, onClose, onLogin }) => {
  const { t } = useTranslation();
  return (
    <Modal
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', top: '80px', zIndex: 9999 }}
      open={show}
      onClose={onClose}
    >
      <Fade in={show}>
        <ModalContents style={{ width: getSemiBigModalWidh() }} onClose={onClose}>
          <LoginPage history={props.history} isPopup={true} />
        </ModalContents>
      </Fade>
    </Modal>
  );
};

//업로드한 pdf 파일이 표준 양식이 아닌 경우 보여주는 모달
export const IsNotAvailablePdfModal = ({ props, show, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', top: '80px' }}
      open={show}
      onClose={onClose}
    >
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
          <ModalTitle>
            <span style={{ fontFamily: 'NSCJKrB' }}>{t('us_copyright_submit_err_subject')}</span>
          </ModalTitle>
          <div
            style={{
              display: 'flex',
              borderTop: '1px solid #eeeeee',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              paddingTop: 10,
            }}
          >
            <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 24 }} />
            <div
              style={{
                fontFamily: 'NSCJKrB',
                color: 'black',
                fontSize: 20,
                textAlign: 'center',
                width: '85%',
                wordBreak: 'keep-all',
              }}
            >
              &nbsp;{t('us_copyright_submit_err')}
            </div>
          </div>

          <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={onClose} style={{ backgroundColor: '#ff8a06' }}>
              {t('confirm')}
            </ModalNorBtn>
          </div>
        </ModalContents>
      </Fade>
    </Modal>
  );
};

//현재 보유하고 있는 크레딧이 없는 경우에 보여주는 모달 (PC 화면과 모바일 화면 구분하기)
export const IsShortOfCreditModal = ({ props, show, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', top: '80px' }}
      open={show}
      onClose={onClose}
    >
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
          <ModalTitle>{t('shortof_credit')}</ModalTitle>
          <div
            style={{
              display: 'flex',
              borderTop: '1px solid #eeeeee',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              paddingTop: 10,
            }}
          >
            <div style={{ fontFamily: 'NSCJKrM', color: 'black', fontSize: 20 }}>{t('shortof_credit_desc1')}</div>
            <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 18 }}>{t('shortof_credit_desc2')}</div>
          </div>
          <VerticalSp sp={'1vw'} style={{ maxHeight: 34, minHeight: 24 }} />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <img alt="" src={images.credit_active} style={{ width: '20px', height: '20px' }} />
            <div style={{ fontFamily: 'NSCJKrB', fontSize: 20, color: '#ff8a06' }}> {t('shortof_credit_desc3')} </div>
            &nbsp; &nbsp;
            <div style={{ fontFamily: 'NSCJKrB', fontSize: 20, color: 'black' }}> 0 {t('credit2')} </div>
          </div>

          <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ModalNorBtn onClick={onClose} style={{ backgroundColor: '#cccccc' }}>
              {t('cancel')}
            </ModalNorBtn>
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={onConfirm} style={{ backgroundColor: '#ff8a06' }}>
              {t('buy')}
            </ModalNorBtn>
          </div>
        </ModalContents>
      </Fade>
    </Modal>
  );
};

export const BasketModal = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
      open={show}
      onClose={onClose}
    >
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
          <ModalTitle>{t('add_to_cart2')}</ModalTitle>
          <div
            style={{
              display: 'flex',
              borderTop: '1px solid #eeeeee',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              paddingTop: 10,
            }}
          >
            <img alt="" src={images.modal_basket} style={{ margin: '20px 0px' }} />
            <div style={{ fontFamily: 'NSCJKrM', color: 'black', fontSize: 20, textAlign: 'center' }}>
              {t('products_are_added')}
            </div>
            <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 18 }}>{t('check_it_now')}</div>
          </div>
          <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ModalNorBtn onClick={onClose} style={{ backgroundColor: '#cccccc' }}>
              {t('cancel')}
            </ModalNorBtn>
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={onConfirm} style={{ backgroundColor: '#ff8a06' }}>
              {t('confirm')}
            </ModalNorBtn>
          </div>
        </ModalContents>
      </Fade>
    </Modal>
  );
};

export const FavoriModal = ({ show, onClose, onConfirm, target, onOffLike }) => {
  const { interest_group, interest_list } = store.getState();
  const getInterest = async () => {
    const res = await apiClient.get('/web/interest');
    if (res) {
      let interest_array = [];

      for (var i = 0; i < res.data.length; i++) {
        for (var k = 0; k < res.data[i].interest_product.length; k++) {
          if (!interest_array.includes(res.data[i].interest_product[k].product_id)) {
            interest_array.push(res.data[i].interest_product[k].product_id);
          }
        }
      }
      store.dispatch({
        type: 'set',
        payload: {
          interest_list: interest_array,
          interest_group: res.data,
        },
      });
    }
  };

  const addInterest = async (group) => {
    const res = await apiClient.post('/web/interest/product', {
      group_id: group,
      product_id: target,
    });

    if (res) {
      const err = CONFIG_MESSAGE.SUCCESS_ADD_FAVORITE_PRODUCT_MSG;

      alert(getStringByLang(res.data.message_ko, res.data.message_en, err));
      getInterest();
      if (onOffLike) {
        onOffLike();
      }

      onClose();
    }
  };

  const removeInterest = async (group) => {
    const res = await apiClient.delete(`/web/interest/product/${group}/${target}`);

    if (res) {
      const err = CONFIG_MESSAGE.SUCCESS_REMOVE_FAVORITE_PRODUCT_MSG;
      alert(getStringByLang(res.data.message_ko, res.data.message_en, err));
      getInterest();
      if (onOffLike) {
        onOffLike();
      }
      onClose();
    }
  };

  const { t } = useTranslation();
  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={show} onClose={onClose}>
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
          <div style={{ width: '98%', display: 'flex', justifyContent: 'space-between', paddingBottom: 10 }}>
            <div style={{ display: 'flex' }}>
              <ModalTitle>{t('save_fav_box')}</ModalTitle>
            </div>
            <div style={{ display: 'flex' }}>
              <BorderBtn
                onClick={onConfirm}
                style={{ height: 25, marginRight: isMobile ? 20 : 10 }}
                // style={{position: 'absolute', top: 15, right: 50}}
              >
                <img alt="" src={images.icon_edit} style={{ marginRight: 4 }} />
                {t('edit_group')}
              </BorderBtn>
            </div>
          </div>

          {interest_group.length > 2 ? (
            <div style={{ width: '100%', height: 400, overflowX: 'hidden', overflowY: 'scroll' }}>
              {interest_group.map((item, index) => (
                <FavDesignItem
                  key={`fav-${index}`}
                  favimg={
                    item.interest_product.length > 0
                      ? `${process.env.REACT_APP_S3_BUCKET_DOMAIN}${getPrewImage(
                          item.interest_product[0].product.product_preview,
                          'small',
                        )}`
                      : `${images.img_blank}`
                  }
                  title={item.group_name}
                  state={interest_list && interest_list.includes(parseInt(target))}
                  onRegClick={() => addInterest(item.ir_group_id)}
                  onUnRegClick={() => removeInterest(item.ir_group_id)}
                />
              ))}
            </div>
          ) : (
            <>
              {interest_group.map((item, index) => (
                <FavDesignItem
                  key={`fav-${index}`}
                  favimg={
                    item.interest_product.length > 0
                      ? `${process.env.REACT_APP_S3_BUCKET_DOMAIN}${getPrewImage(
                          item.interest_product[0].product.product_preview,
                          'small',
                        )}`
                      : `${images.img_blank}`
                  }
                  title={item.group_name}
                  state={interest_list && interest_list.includes(parseInt(target))}
                  onRegClick={() => addInterest(item.ir_group_id)}
                  onUnRegClick={() => removeInterest(item.ir_group_id)}
                />
              ))}
            </>
          )}
          {/* <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} /> */}
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ModalNorBtn onClick={onClose} style={{ backgroundColor: '#cccccc', fontSize: 14 }}>
              {t('close')}
            </ModalNorBtn>
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={onConfirm} style={{ backgroundColor: '#ff8a06', width: 180, fontSize: 14 }}>
              {t('edit_fav_box')}
            </ModalNorBtn>
          </div> */}
        </ModalContents>
      </Fade>
    </Modal>
  );
};

export const SurvayTitle = styled.div`
  font-size: 26px;
  font-weight: bold;
  color: black;
`;
export const SurvaySubTitle = styled.div`
  font-size: 21px;
  font-weight: bold;
  color: black;
`;
export const SurvaySubContent = styled.div`
  font-size: 16px;
  color: black;
`;
const InputPad = styled.div`
  padding: 9px;
  display: flex;
  align-items: center;
`;
const CouponWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const CouponVisibleBox = styled.div`
  ${(props) =>
    props.visible
      ? css`
          display: block;
        `
      : css`
          display: none;
        `};
`;

export const SurveyModal = ({ show, onClose, user_uuid }) => {
  const { t } = useTranslation();
  const [isSeller, setIsSeller] = useState(false);
  const [isBuyer, setIsBuyer] = useState(false);
  const [company, setCompany] = useState('');
  const [coupon, setCoupon] = useState('');

  const closeModal = async () => {
    const res = await apiClient.post(`/web/survey/user/${user_uuid}`, {
      is_tooked_survey: true,
    });
    onClose();
  };
  const addCoupon = async () => {
    const res = await apiClient.post(`/web/survey/coupon/${user_uuid}`, {
      company: company,
    });
    if (res) {
      if (res.status === 200 && Store.get('lang') === 'kr') {
        return alert(res.data.message_ko);
      }
    }

    // onClose();
  };
  const sendSurvey = async () => {
    const res = await apiClient.post(`/web/survey/user/${user_uuid}`, {
      is_seller: isSeller,
      is_buyer: isBuyer,
      company: company,
      is_tooked_survey: true,
    });

    if (res) {
      if (Store.get('lang') === 'kr') {
        alert(res.data.message_ko);
      } else {
        alert(res.data.message_en);
      }
      return window.location.reload();
    }

    onClose();
  };

  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={show} onClose={closeModal}>
      <Fade in={show}>
        <ModalContents style={{ width: getModalWidh() }} onClose={sendSurvey}>
          {/* <SurvaySubTitle>{t('survay')}</SurvaySubTitle> */}
          <SurvaySubTitle>{t('survay_purpose')}</SurvaySubTitle>
          <VerticalSp sp={30} />
          <VerticalSp sp={5} />
          <SurvaySubContent>{t('survay_mutiple_selection')}</SurvaySubContent>

          <FormGroup>
            <CheckboxWrapper>
              <FormControlLabel
                control={<Checkbox checked={isBuyer} onChange={() => setIsBuyer((item) => !item)} />}
                label={t('survay_selection_buyer')}
              />
              <FormControlLabel
                control={<Checkbox checked={isSeller} onChange={() => setIsSeller((item) => !item)} />}
                label={t('survay_selection_seller')}
              />
            </CheckboxWrapper>
          </FormGroup>
          <VerticalSp sp={10} />
          <CouponVisibleBox visible={isBuyer}>
            <SurvaySubTitle>{t('survay_company')}</SurvaySubTitle>
            <VerticalSp sp={5} />
            <SurvaySubContent>{t('survay_coupon')}</SurvaySubContent>

            <VerticalSp sp={10} />
            <CouponWrapper>
              <InputGroup style={{ flex: 1 }}>
                <InputPad>
                  <InputBase
                    type="input"
                    value={coupon ? coupon : company}
                    placeholder={t('survay_input_company')}
                    inputProps={{ style: inputStyle }}
                    style={{ width: '100%' }}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                </InputPad>
              </InputGroup>
              <HorizontalSp sp={10} />
              <ModalNorBtn onClick={addCoupon} style={{ backgroundColor: '#ff8a06', width: 115, fontSize: 20 }}>
                {t('survay_get_promotion_code')}
              </ModalNorBtn>
            </CouponWrapper>
          </CouponVisibleBox>
          <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* <ModalNorBtn onClick={closeModal} style={{ backgroundColor: '#cccccc', fontSize: 14 }}>
              {t('close')}
            </ModalNorBtn> */}
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={sendSurvey} style={{ backgroundColor: '#ff8a06', width: 180, fontSize: 20 }}>
              {t('survay_send')}
            </ModalNorBtn>
          </div>
        </ModalContents>
      </Fade>
    </Modal>
  );
};
